import {forwardRef} from "react";
import block from 'bem-css-modules';
import s from './RadioButton.module.scss';

const b = block(s);

const RadioButton = forwardRef(({item, onBlur, onChange, selectedValue, name='input-radio'}, ref) => {
    const {id, label, logo_url: logoUrl} = item;
    const selected = `${selectedValue}` === `${item.id}`;

    return (<label htmlFor={`${name}-${item.id}`} className={b('label', {selected})}>
        <input
            ref={ref}
            className={b('input')}
            type='radio'
            id={`${name}-${id}`}
            value={id}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            checked={selected}/>
        {label && <span className={b('label-text')}>{label}</span>}
        {logoUrl && <img className={b('logo')} alt={label} src={logoUrl}/>}
    </label>);
})

export default RadioButton;